import Car01 from '../../Assets/jpg/car01.jpg';
import Car02 from "../../Assets/jpg/car02.jpg";
import Car03 from '../../Assets/jpg/car03.jpg';
import Car04 from '../../Assets/jpg/car04.jpg';
import Car05 from '../../Assets/jpg/car05.jpg';
import Car06 from '../../Assets/jpg/car06.jpg';
import Car07 from '../../Assets/jpg/car07.jpg';
import Car08 from '../../Assets/jpg/car08.jpg';

const Data=[
    {
        id:1,
        name:"Mercedes Benz Car",
        review:"5.0(58.5k Review)",
        img:Car01,
        drive:"Automatic",
        km:"10.15km/1-litre",
        model:"2023",
        fuel:"Hybrid",
        price:"$45,620",
        view:"Details"
    },
    {
        id:2,
        name:"Yellow Ferrari 458",
        review:"5.0(58.5k Review)",
        img:Car02,
        drive:"Automatic",
        km:"10.15km/1-litre",
        model:"2023",
        fuel:"Hybrid",
        price:"$90,250",
        view:"Details"
    },
    {
        id:3,
        name:"Black Audi Q7",
        review:"5.0(58.5k Review)",
        img:Car03,
        drive:"Automatic",
        km:"10.15km/1-litre",
        model:"2023",
        fuel:"Hybrid",
        price:"$44,350",
        view:"Details"
    },
    {
        id:4,
        name:"BMW Sports Car",
        review:"5.0(58.5k Review)",
        img:Car04,
        drive:"Automatic",
        km:"10.15km/1-litre",
        model:"2023",
        fuel:"Hybrid",
        price:"$78,760",
        view:"Details"
    },
    {
        id:5,
        name:"White Tesla Car",
        review:"5.0(58.5k Review)",
        img:Car05,
        drive:"Automatic",
        km:"10.15km/1-litre",
        model:"2023",
        fuel:"Hybrid",
        price:"$64,230",
        view:"Details"
    },
    {
        id:6,
        name:"White Nissan Car",
        review:"5.0(58.5k Review)",
        img:Car06,
        drive:"Automatic",
        km:"10.15km/1-litre",
        model:"2023",
        fuel:"Hybrid",
        price:"$34,540",view:"Details"
    },
    {
        id:7,
        name:"Mercedes Benz Suv",
        review:"5.0(58.5k Review)",
        img:Car07,
        drive:"Automatic",
        km:"10.15km/1-litre",
        model:"2023",
        fuel:"Hybrid",
        price:"$75,820",
        view:"Details"
    },
    {
        id:8,
        name:"Red Hyundai Car",
        review:"5.0(58.5k Review)",
        img:Car08,
        drive:"Automatic",
        km:"10.15km/1-litre",
        model:"2023",
        fuel:"Hybrid",
        price:"$25,260",
        view:"Details"
    },
];

export default Data;